import core from '@/store/modules/core'
import search from '@/store/modules/search'

const storeConfig = { modules: { core, search } }

export default storeConfig
